import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchSO01history = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetSO01OpmHistory`);

  return response.data.data;
};

export const useSO01history = (enabled = true) =>
  useQuery({
    queryKey: ["SO01History"],
    queryFn: () => fetchSO01history(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    gcTime: 5 * 60 * 1000, // cache for 5 min if unfocused
  });
